import { hasCapability, type User } from "../base";

export const notificationSettings = {
  view: (user: User) => hasCapability(user, "notificationSettings.view"),
};
